import { FetchStatus, TCovenantsPageStore, TAsyncSlice } from './types';

export function makeRequestState<T>(emptyData: T): TAsyncSlice<T> {
  return {
    data: emptyData,
    status: FetchStatus.Idle,
    error: null,
  };
}

export const initialState: TCovenantsPageStore = {
  contragents: makeRequestState([]),
  currentContragent: makeRequestState(null),
  supervisorContragentBlocks: makeRequestState({
    blocks: [],
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  requiredDocuments: makeRequestState({
    requiredDocuments: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  covenants: makeRequestState({
    covenants: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 5,
      totalElements: 0,
    },
  }),
  applications: makeRequestState({
    applications: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  activeApplications: makeRequestState({
    applications: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 4,
      totalElements: 0,
    },
  }),
  supervisorSegments: makeRequestState([]),
  supervisorApplications: makeRequestState({
    supervisorApplications: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  supervisorReadyCovenants: makeRequestState({
    covenants: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  currentSupervisorApplication: makeRequestState(null),
  supervisorApplicationDocuments: makeRequestState({
    applicationId: undefined,
    documents: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  currentApplication: makeRequestState(null),
  applicationDocuments: makeRequestState({
    applicationDocuments: [],
    count: 0,
    pageConfiguration: {
      page: 0,
      size: 10,
      totalElements: 0,
    },
  }),
  applicationUnsignedDocumentsCount: makeRequestState(null),
  documentGenerationBanks: makeRequestState([]),
  documentGenerationCurrencies: makeRequestState([]),
  certificateGeneration: {
    stateAidReceived: makeRequestState(null),
    financialCondition: makeRequestState(null),
    incomeStructureByKved: makeRequestState(null),
  },
  saveSignedDocumentsFromDiia: {
    status: FetchStatus.Idle,
    error: null,
  },
  accessDeniedModal: {
    open: false,
    message: '',
    redirectPath: null,
  },
};
